module.exports = __webpack_public_path__ + "img/7.93c5ed84.jpg";